import { render, staticRenderFns } from "./OperationTypeUpdate.vue?vue&type=template&id=66b22514&"
import script from "./OperationTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./OperationTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports